import { render } from "./ImageManager.vue?vue&type=template&id=433f12e6"
import script from "./ImageManager.vue?vue&type=script&lang=js"
export * from "./ImageManager.vue?vue&type=script&lang=js"

import "./ImageManager.vue?vue&type=style&index=0&id=433f12e6&lang=css"

import exportComponent from "/home/mihai/repos/skinscience/skinatlas/src/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__